import { render, staticRenderFns } from "./KernelPressSheets.vue?vue&type=template&id=606df6be&"
import script from "./KernelPressSheets.vue?vue&type=script&lang=js&"
export * from "./KernelPressSheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports